import type { PropsWithChildren } from 'react';

import { Spin } from 'antd';

import { FetchErrorSection } from '..';
import { Loader } from '../Loader/Loader';

import styles from './FetchDataWrapper.module.scss';

interface IProp {
  isError: boolean;
  isLoading: boolean;
  isModalUse?: boolean;
  refreshCb?: VoidFunction;
}

export const FetchDataWrapper = ({ isError, isLoading, isModalUse, refreshCb, children }: PropsWithChildren<IProp>) => {
  if (isError) {
    return (
      <FetchErrorSection
        onRetry={refreshCb}
        retryText={refreshCb ? 'Запросить данные повторно' : 'Обновить страницу'}
      />
    );
  }

  if (isModalUse) {
    return (
      <div className={styles['modal-loader-wrapper']}>
        <Spin spinning={isLoading}>{children}</Spin>
      </div>
    );
  }

  if (isLoading) {
    return <Loader isSpinning />;
  }

  return children;
};
